<template>
  <div class="page-content">
    <div class="page-body-test-view">
      <div class="container">
        <button @click="onCreate()" class="btn btn-primary">Create</button>
        <div class="dashboard-content">
          <div
            class="design-item"
            @click="onSelect(design.id)"
            v-for="design in designs"
            :key="design.id"
          >
            {{ design.name }}
          </div>
        </div>
        {{ designs }}
        <div>
          Selected <span>{{ selectedName }}</span>
        </div>
        <div v-if="selected">{{ config }}</div>

        <button @click="onUpdate()" class="btn btn-primary">Increase</button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { HTTP } from '@/shared/http';

export default {
  name: 'MyDashboard',
  components: {},

  data() {
    return {
      designs: null,
      selected: null,
    };
  },

  methods: {
    onSelect(id) {
      this.selected = id;
    },

    onCreate() {
      const url = 'api/designs/';

      const name = 'test 42';
      const config = {};
      config.reminder = 2;
      config.logoImg = null;
      HTTP.post(url, { name, config })
        .then((response) => {
          console.log('Processing the updated designs:', response);
        })
        .catch((error) => console.log(error));
    },

    onUpdate() {
      if (!this.selected) return null;

      const design = this.designs.find((d) => {
        console.log('Test:', d.id, this.selected);
        return d.id == this.selected;
      });

      if (design) {
        design.config.reminder++;
        const url = 'api/designs/' + design.id;

        HTTP.put(url, { config: design.config })
          .then((response) => {
            console.log('Processing the updated designs:', response);
          })
          .catch((error) => console.log(error));
      }
    },
  },

  computed: {
    config() {
      console.log('config for:', this.selected);
      if (!this.selected) return null;

      const design = this.designs.find((d) => {
        console.log('Test:', d.id, this.selected);
        return d.id == this.selected;
      });
      console.log('config :', design);
      return design?.config;
    },

    selectedName() {
      console.log('config for:', this.selected);
      if (!this.selected) return null;

      const design = this.designs.find((d) => {
        console.log('Test:', d.id, this.selected);
        return d.id == this.selected;
      });
      console.log('config :', design);
      return design?.name;
    },
  },
  mounted() {
    this.$store.commit('setVisibleNav', true);

    const url = 'api/designs';

    HTTP.get(url)
      .then((response) => {
        console.log('Processing the loaded designs:', response);
        this.designs = response.data;
      })
      .catch((error) => console.log(error));
  },
};
</script>

<style lang="scss">
@import '@/styles/style.scss';

.email-content {
  max-width: 600px;
  margin: 0 auto;
}

.page-content {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-color: $very-light-grey;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.page-body-test-view {
  overflow: auto;
  margin-top: 100px;
}

.design-item {
  padding: 5px;
  background-color: bisque;
  margin: 5px;
  cursor: pointer;
}

.dashboard-content {
  display: flex;
  flex-direction: column;
}

.dashboard-margin {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-left: $mobile-margin-left;
  padding-right: $mobile-margin-left;
}

@media screen and (min-width: 960px) {
  .dashboard-margin {
    margin-left: $desktop-margin-left !important;
    padding: 0px;
  }
}
</style>
